export async function registerServiceWorker(): Promise<void> {
 if(import.meta.env.VITE_CHANNEL==="apps_in_toss"||!("serviceWorker" in navigator)||import.meta.env.DEV)return;
 try {
  const registration=await navigator.serviceWorker.register("/sw.js",{scope:"/"});
  dispatchEvent(new Event("arabom:sw-ready"));
  const notify=()=>{if(registration.active&&registration.waiting)dispatchEvent(new Event("arabom:update-available"))};
  registration.addEventListener("updatefound",()=>registration.installing?.addEventListener("statechange",notify));notify();
  const badging=navigator as Navigator & {clearAppBadge?:()=>Promise<void>};await badging.clearAppBadge?.();
 }catch{dispatchEvent(new Event("arabom:offline-unavailable"))}
}
